/** Desktop + structural rules for the design canvas (no @media / @container). */
const EMAIL_CANVAS_SCOPE = '#main-canvas';

export const EMAIL_BASE_CSS = `
${EMAIL_CANVAS_SCOPE} img:not(.email-img-bg-fallback) { max-width: 100% !important; height: auto !important; }
${EMAIL_CANVAS_SCOPE} .email-col { box-sizing: border-box !important; }
${EMAIL_CANVAS_SCOPE} .email-inner > tbody > tr > td,
${EMAIL_CANVAS_SCOPE} .email-content-card td {
  box-sizing: border-box !important;
}
${EMAIL_CANVAS_SCOPE} .email-surface-cell {
  overflow: hidden !important;
}
${EMAIL_CANVAS_SCOPE} .email-inner p,
${EMAIL_CANVAS_SCOPE} .email-inner h1,
${EMAIL_CANVAS_SCOPE} .email-inner h2,
${EMAIL_CANVAS_SCOPE} .email-inner h3,
${EMAIL_CANVAS_SCOPE} .email-inner h4,
${EMAIL_CANVAS_SCOPE} .email-inner h5,
${EMAIL_CANVAS_SCOPE} .email-inner h6 {
  margin: 0 !important;
  font: inherit !important;
}
${EMAIL_CANVAS_SCOPE} .email-inner {
  letter-spacing: normal;
  font-weight: 400;
  -webkit-font-smoothing: auto;
  -moz-osx-font-smoothing: auto;
  text-rendering: auto;
}
${EMAIL_CANVAS_SCOPE} .email-content-card {
  width: 100%;
  max-width: 100%;
}
${EMAIL_CANVAS_SCOPE} .email-img-bg-fallback { max-width: 100% !important; }
${EMAIL_CANVAS_SCOPE} .email-img-fill-col .email-img-bg-fallback {
  height: 100% !important;
}
${EMAIL_CANVAS_SCOPE} .email-img-fill-col,
${EMAIL_CANVAS_SCOPE} .email-img-fill-col > tbody,
${EMAIL_CANVAS_SCOPE} .email-img-fill-col > tbody > tr,
${EMAIL_CANVAS_SCOPE} .email-img-fill-col .email-img-bg-td {
  height: 100% !important;
}
`.trim();
